import React, { useState } from 'react';
import { message } from 'antd';
import { paymentUpdate } from "../../api/PupilApi";

const PaymentUpdateModal = ({ isOpen, onClose, onSuccess, invoiceData }) => {
  const [paymentAmount, setPaymentAmount] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('');
  const [paymentDate, setPaymentDate] = useState('');
  const [transactionRefId, setTransactionRefId] = useState('');
  const [loading, setLoading] = useState(false);

  const data = invoiceData?.taxInvoiceDataInfo;
  if (!isOpen || !data) return null;
  console.log(JSON.stringify(data));
  const invoiceNo = data?.invoiceNo || "N/A";

  const createdAt = invoiceData?.createdAt || "";
  const category = invoiceData?.category || "";
  const pupilEmail = invoiceData?.pupilEmail || "";
  const balanceAmount = Math.abs(Number(data?.balance || 0));

  const handlePayment = async () => {
    if (!paymentMethod) return message.warning("Please select a payment method");
    if (!paymentAmount || Number(paymentAmount) <= 0) return message.warning("Enter valid amount");
    if (Number(paymentAmount) > balanceAmount) return message.warning("Amount exceeds balance");

    try {
      setLoading(true);
      const payload = {
        invoiceNo,
        paymentAmount: Number(paymentAmount),
        paymentMethod,
        balance: data.balance,
        totalAmount: data.totalAmount,
        createdAt,
        category,
        pupilEmail,
        transactionRefId,
        paymentDate
      };

      alert(`🧾 Payment Debug:
  Invoice No: ${invoiceNo}
  Created At: ${createdAt}
  Category: ${category}
  email: ${pupilEmail}
  Amount: ₹${paymentAmount}
  Method: ${paymentMethod}
  Transaction ID: ${transactionRefId}
  PaymentDate: ${paymentDate}`
  
);

      const response = await paymentUpdate(payload);

      if (response.data?.success) {
        message.success("Payment updated successfully");
        onSuccess();
        onClose();
      } else {
        message.error(response.data?.message || "Failed to update payment");
      }
    } catch (error) {
      message.error("An error occurred while updating payment");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-xl w-96 shadow-xl relative">
        <button 
          onClick={onClose} 
          className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
          disabled={loading}
        >
          ✕
        </button>

        <h2 className="text-xl font-semibold mb-4 text-center">Payment Update</h2>
        <div className="mb-4">
          <p className="text-gray-700">
            <span className="font-medium">Invoice No:</span> {invoiceNo}
          </p>
          <p className="text-gray-700">
            <span className="font-medium">Balance Amount:</span> ₹{balanceAmount.toFixed(2)}
          </p>
        </div>

        <div className="mb-3">
          <label className="block text-gray-700 mb-1">Payment Amount (₹)</label>
          <input
            type="number"
            placeholder="Enter amount"
            className="w-full border rounded px-3 py-2"
            value={paymentAmount}
            min="0"
            max={balanceAmount}
            onChange={(e) => {
              const value = e.target.value;
              if (value === '' || /^\d*\.?\d*$/.test(value)) {
                setPaymentAmount(value);
              }
            }}
            disabled={loading}
          />
        </div>
        <div className="mb-3">
          <label className="block text-gray-700 mb-1">Payment Date</label>
          <input
            type="date"
            className="w-full border rounded px-3 py-2"
            value={paymentDate}
            onChange={(e) => setPaymentDate(e.target.value)}
            disabled={loading}
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 mb-1">Payment Method</label>
          <select
            className="w-full border rounded px-3 py-2"
            value={paymentMethod}
            onChange={(e) => setPaymentMethod(e.target.value)}
            disabled={loading}
          >
            <option value="">Select Payment Method</option>
            <option value="Cash">Cash</option>
            <option value="UPI">UPI</option>
            <option value="Bank Transfer">Bank Transfer</option>
            <option value="Cheque">Cheque</option>
            <option value="Credit Card">Credit Card</option>
            <option value="Debit Card">Debit Card</option>
          </select>
        </div>
        <div className="mb-3">
          <label className="block text-gray-700 mb-1">Transaction Reference ID</label>
          <input
            type="text"
            placeholder="Enter transaction reference ID"
            className="w-full border rounded px-3 py-2"
            value={transactionRefId}
            onChange={(e) => setTransactionRefId(e.target.value)}
            disabled={loading}
          />
        </div>

        <button
          className={`w-full px-4 py-2 rounded text-white ${
            !paymentAmount || !paymentMethod || Number(paymentAmount) > balanceAmount
              ? 'bg-gray-400 cursor-not-allowed'
              : 'bg-green-600 hover:bg-green-700'
          }`}
          onClick={handlePayment}
          disabled={!paymentAmount || !paymentMethod || Number(paymentAmount) > balanceAmount || loading}
        >
          {loading ? 'Processing...' : 'Update Payment'}
        </button>
      </div>
    </div>
  );
};

export default PaymentUpdateModal;
